import { render, staticRenderFns } from "./table-page.vue?vue&type=template&id=4439eaee&scoped=true"
import script from "./table-page.vue?vue&type=script&lang=js"
export * from "./table-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4439eaee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4439eaee')) {
      api.createRecord('4439eaee', component.options)
    } else {
      api.reload('4439eaee', component.options)
    }
    module.hot.accept("./table-page.vue?vue&type=template&id=4439eaee&scoped=true", function () {
      api.rerender('4439eaee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CommonForm/table-page.vue"
export default component.exports